import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const infiniteOptionsWidget: ComponentTemplate = {
  id: "14ef087c-f182-4838-9c3b-0b2c70bc33eb",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Infinite Options Widget",
  leftBarCategory: {
    main: "productIntegrations",
    subCategory: "infiniteOptions",
  },
  preview: "product/infinite-options.svg",
  transforms: [],
  template: {
    id: "$uid",
    type: "infiniteOptionsWidget",
    props: {},
  },
};
